<template>
<div v-if="Access('FinancialRead')" :id="'CookiesDialog_' + DialogIndex" class="CookiesDialogdBody">
  <div class="M-Auto DialogContainer">
    <div class="DialogBody color2">
      <div class=" D-Flex W-100" style="text-align:left; margin-bottom:15px; white-space: nowrap;">
      </div>
      <!-- Driver -------------------------------------- -->
      <div class="D-Flex W-100 FlexWrap">
        <div class="DefaultTextAlign W-25" style="padding: 3em; flex: 1;">
          <div class="W-100">
            <span class="color2">{{LanguageSelector('Driver: ', 'السائق: ')}}</span>
          </div>
          <div class="W-100">
            <span class="F1_25em F-Bold color2">{{DeepFetcher(TheUser, ['Employee', 'Name'])}}</span>
          </div>
          <div class="W-100">
            <span class="F1_25em F-Bold color2">{{DeepFetcher(TheUser, ['Employee', 'PhoneNumber'])}}</span>
          </div>
          <div class="CookiesRowSplitter"/>
          <div class="W-100">
            <button :class="CookiesDataLedgerOrders.length === 0 ? 'Disabled' : ''" style="margin: 0.5em;" class="CookiesButton BGThird F-Bold" v-if="Access('Settlement')" @click="Settlement()"><span>{{LanguageSelector('Settlement', 'تسوية الحساب')}}</span><CookiesIcon :Color="'Black'" class="CookiesButtonIcon" :ID="'Settlement'"></CookiesIcon></button>
            <button style="margin: 0.5em;" class="CookiesButton BGThird F-Bold" v-if="Access('FinancialAdd')" @click="NewTrans()"><span>{{LanguageSelector('Add Transaction', 'حركة جديدة')}}</span></button>
          </div>
        </div>
        <div class="M-Auto W-75" style="flex: 2;">
          <div v-if="CookiesCashLedger" class="M-Auto D-Flex W-100" style="filter: drop-shadow(var(--shadow0)); border-radius: 0.5em;">
            <div class="W-100 BG2 D-Flex M-Auto" style="text-align: center; padding: 0.8em 1.5em; filter: drop-shadow(var(--shadow0)); height: 90%" :style="$store.getters.Direction === 'ltr' ? 'border-radius: 0.5em 0 0 0.5em;' : 'border-radius: 0 0.5em 0.5em 0;'">
              <div class="M-Auto O-85">
                <span style="">{{LanguageSelector('Balance In', 'الايرادات')}}</span>
                <div class="CookiesRowSpacer"/>
                <span style="display: inline;" class="F1_5em">{{DeepFetcher(CookiesCashLedger, ['Debited'])}}</span><br><span> {{$store.state.CookiesConfig.PriceUnit}}</span>
                <CookiesUpDownArrow class="F1_5em" :Direction="'UP'" :Value="DeepFetcher(CookiesCashLedger, ['Debited'])" style="margin-top: 0.5em; margin-bottom: -0.5em;"></CookiesUpDownArrow>
                <div class="CookiesRowSpacer"/>
              </div>
            </div>
            <div class="W-100 BG6 D-Flex" style="text-align: center; padding: 0.8em 1.5em; border-radius: var(--rad2); filter: drop-shadow(var(--shadow0)); z-index:5">
              <div class="M-Auto">
                <span style="">{{LanguageSelector('Net Balance', 'الاجمالي')}}</span>
                <div class="CookiesRowSpacer"/>
                <span style="display: inline;" class="F2_5em F-Bold" :style="DeepFetcher(CookiesCashLedger, ['NetBalance']) < 0 ? 'color: var(--colorr1)': ''"> {{DeepFetcher(CookiesCashLedger, ['NetBalance']) ? DeepFetcher(CookiesCashLedger, ['NetBalance']) : '0' }}</span><br><span :style="DeepFetcher(CookiesCashLedger, ['NetBalance']) < 0 ? 'color: var(--colorr1)': ''" class="F-Bold"> {{$store.state.CookiesConfig.PriceUnit}}</span>
                <div class="CookiesRowSpacer"/>
              </div>
            </div>
            <div class="W-100 BG2 D-Flex M-Auto" style="text-align: center; padding: 0.8em 1.5em; filter: drop-shadow(var(--shadow0)); height: 90%" :style="$store.getters.Direction === 'ltr' ? 'border-radius: 0 0.5em 0.5em 0;' : 'border-radius: 0.5em 0 0 0.5em;'">
              <div class="M-Auto O-85">
                <span style="">{{LanguageSelector('Balance Out', 'المدفوعات')}}</span>
                <div class="CookiesRowSpacer"/>
                <span style="display: inline;" class="F1_5em">{{DeepFetcher(CookiesCashLedger, ['Credited'])}}</span><br><span> {{$store.state.CookiesConfig.PriceUnit}}</span>
                <CookiesUpDownArrow class="F1_5em" :Direction="'DOWN'" :Value="DeepFetcher(CookiesCashLedger, ['Credited'])" style="margin-top: 0.5em; margin-bottom: -0.5em;"></CookiesUpDownArrow>
                <div class="CookiesRowSpacer"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Data Block >>>>>>>>>>>>>>>>>>>>>>>>>>>>>> -->
      <div id="TableToPrint1" class="W-100 F_75em Shadow1" style="padding:5px">
        <div><span class="F1_5em F-Bold JustPrint D-None">{{LanguageSelector('Driver: ', 'السائق: ')}}{{DialogData.Employee.Name}}</span></div>
        <div class="CookiesRowSplitter NOPRINT"/>
        <div :class="CookiesDataLedgerOrders.length === 0 ? 'Disabled' : ''" @click="printIT(1)" class="PrintButton D-Flex NOPRINT">
          <CookiesIcon style="width: 1.2em; height:1.2em; margin: 0 0.5em;" :ID="'Printer'"></CookiesIcon>
          <span class="F-Bold M-Auto">{{LanguageSelector('Print', 'طباعة')}}</span>
        </div>
        <div class="M-Auto" style="">
          <!-- Orders Table /////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
          <CookiesTable :Loading="OrdersLoading" :PrintControls="false" :TableName="LanguageSelector('Orders','الطلبات')" :Data="CookiesDataLedgerOrders" :Fields="Fields"></CookiesTable>
        </div>
        <div class="CookiesRowSpacer"/>
        <div class="P_5em D-Flex"><span style="font-size: 17pt !important">{{LanguageSelector('Total amount for delivered orders: ', 'مجموع قيم الطلبات المحصلة: ')}} <span style="color: var(--colorg3); font-size: 17pt !important">{{TotalOf(CookiesDataLedgerOrders, 'AmountTotalCollected')}}</span> {{PriceUnit}}</span></div>
        <div class="P_5em D-Flex"><span style="font-size: 17pt !important">{{LanguageSelector('Total amount for Delivery Fees: ', 'عمولة السائق: ')}} <span style="color: var(--colorr1); font-size: 17pt !important">{{TotalOf(CookiesDataLedgerOrders, 'DriverExtraFees')}}</span> {{PriceUnit}}</span></div>
        <div class="P_5em D-Flex"><span style="font-size: 17pt !important">{{LanguageSelector('Total amount for Delivery Fees: ', 'مجموع قيم التوصيل: ')}} {{TotalOf(CookiesDataLedgerOrders, 'Fees')}} {{PriceUnit}}</span></div>
        <div class="P_5em D-Flex"><span style="font-size: 20pt !important">{{LanguageSelector('Total amount owed to the customer: ', 'مجموع القيم المطلوبه من السائق: ')}} <span class="F-Bold color1" style="font-size: 20pt !important">{{DeepFetcher(CookiesCashLedger, ['NetBalance']) ? DeepFetcher(CookiesCashLedger, ['NetBalance']) : '0' }} {{PriceUnit}}</span></span></div>
      </div>
      <div class="W-100" style="padding:5px">
        <div class="CookiesRowSplitter"/>
        <div class="CookiesRowSpacer"/>
        <!-- Oldeer Downloads /////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
        <div class="W-100 F-Bold">
          <span>{{LanguageSelector('Account History', 'تاريخ الحساب')}}</span>
        </div>
        <div class="M-Auto" style="max-height:400px; overflow-y:scroll;">
          <button @click="OpenOlderBalances()" class="CookiesButton BG2">{{LanguageSelector('View', 'عرض')}}</button>
          <!-- <table class="Cookies_Table1 Cookies_TableButtons" style="position: relative; border-radius:var(--rad2); min-width: 75%; margin: auto;"  cellspacing="0" cellpadding="0">
            <tr class="Disabled" v-if="!CookiesDataBalanceHis.length"><td colspan="10">{{LanguageSelector('No Entries','لا يوجد')}}</td></tr>
            <tr @click="OpenOlderBalance(entry)" v-for="entry in GeneralSort(CookiesDataBalanceHis, ['CloseDate'], -1)" :key="entry">
              <td><span>{{JsonDateParser(entry.OpenDate) + ' - '}}</span><strong>{{JsonTimeParser(entry.OpenDate)}}</strong></td>
              <td><strong>-</strong></td>
              <td><span>{{JsonDateParser(entry.CloseDate) + ' - '}}</span><strong>{{JsonTimeParser(entry.CloseDate)}}</strong></td>
              <td class="Arrow"><CookiesUpDownArrow class="F_75em O-75" :Direction="'right'" :Value="1"></CookiesUpDownArrow></td>
            </tr>
          </table> -->
        </div>
        <div class="CookiesRowSpacer"/>
      </div>
    </div>
  </div>
</div>
<div v-if="Access('FinancialRead')" class="CookiesDialogFooter">
  <div class=" F-Bold" style="margin: auto 1em;">
    <button @click="$router.go(-1)" style="background: var(--colorr1);" class="F-Bold CookiesButton DialogFooterButton">{{LanguageSelector('Close', 'خروج')}}</button>
  </div>
</div>

</template>

<script>
export default {
  setup () {},
  components: {},
  beforeCreate () {},
  created () {},
  data () {
    return {
      CookiesDataTransactions: [],
      CookiesDataBalanceHis: [],
      CookiesDataLedgerOrders: [],
      TheUser: {},
      CookiesCashLedger: {},
      OrdersLoading: true,
      ReturnedLoading: true,
      JournalLoading: true,
      Fields: [
        {
          name: 'index',
          noheader: true,
          type: 'index',
          print: false
        },
        {
          name: this.LanguageSelector('Customer', 'العميل'),
          value: ['Customer', 'Name'],
          sort: true
        },
        {
          name: this.LanguageSelector('Order ID', 'رقم الطلب'),
          value: ['ID'],
          sort: true
        },
        {
          name: this.LanguageSelector('Policy', 'البوليصة'),
          value: ['BarCode'],
          sort: true
        },
        {
          name: this.LanguageSelector('Date', 'التاريخ'),
          value: ['SubmissionDate'],
          sort: true,
          type: 'date'
        },
        {
          name: this.LanguageSelector('Time', 'الوقت'),
          value: ['SubmissionDate'],
          sort: true,
          type: 'time'
        },
        {
          name: this.LanguageSelector('Location', 'العنوان'),
          value: ['SubArea']
        },
        {
          name: this.LanguageSelector('Phone Number', 'الهاتف'),
          value: ['Client', 'PhoneNum']
        },
        {
          name: this.LanguageSelector('Order Ammuont', 'قيمة الطلب'),
          value: ['AmountTotal'],
          sort: true,
          type: 'number',
          pricetag: true,
          total: true,
          bold: true
        },
        {
          name: this.LanguageSelector('Collected Amount', 'القيمة المحصلة'),
          value: ['AmountTotalCollected'],
          sort: true,
          type: 'number',
          pricetag: true,
          total: true,
          bold: true
        },
        {
          name: this.LanguageSelector('Delivery Fees', 'عمولة التوصيل'),
          value: ['Fees'],
          sort: true,
          type: 'number',
          pricetag: true,
          total: true,
          bold: true
        },
        {
          name: this.LanguageSelector('Driver Fees', 'عمولة السائق'),
          value: ['DriverExtraFees'],
          sort: true,
          type: 'number',
          pricetag: true,
          total: true,
          bold: true
        },
        {
          name: this.LanguageSelector('Status', 'الحالة'),
          value: ['EncodedStatus'],
          sort: true
        },
        {
          name: this.LanguageSelector('Description', 'ملاحظات'),
          value: ['Notes']
        }
      ],
      ReturnedFields: [
        {
          selector: true,
          Res: 'DR_ReturnedItems_',
          Res_ID: ['ID'],
          DefaultValue: true
        },
        {
          name: 'index',
          noheader: true,
          type: 'index',
          print: false
        },
        {
          name: this.LanguageSelector('Customer', 'العميل'),
          value: ['Customer', 'Name'],
          sort: true
        },
        {
          name: this.LanguageSelector('Order ID', 'رقم الطلب'),
          value: ['ID'],
          sort: true
        },
        {
          name: this.LanguageSelector('Policy', 'البوليصة'),
          value: ['BarCode'],
          sort: true
        },
        {
          name: this.LanguageSelector('Date', 'التاريخ'),
          value: ['SubmissionDate'],
          sort: true,
          type: 'date'
        },
        {
          name: this.LanguageSelector('Time', 'الوقت'),
          value: ['SubmissionDate'],
          sort: true,
          type: 'time'
        },
        {
          name: this.LanguageSelector('Location', 'العنوان'),
          value: ['SubArea']
        },
        {
          name: this.LanguageSelector('Phone Number', 'الهاتف'),
          value: ['Client', 'PhoneNum']
        },
        {
          name: this.LanguageSelector('Order Ammuont', 'قيمة الطلب'),
          value: ['AmountTotal'],
          sort: true,
          type: 'number',
          pricetag: true,
          total: true,
          bold: true
        },
        {
          name: this.LanguageSelector('Collected Amount', 'القيمة المحصلة'),
          value: ['AmountTotalCollected'],
          sort: true,
          type: 'number',
          pricetag: true,
          total: true,
          bold: true
        },
        {
          name: this.LanguageSelector('Delivery Fees', 'عمولة التوصيل'),
          value: ['Fees'],
          sort: true,
          type: 'number',
          pricetag: true,
          total: true,
          bold: true
        },
        {
          name: this.LanguageSelector('Status', 'الحالة'),
          value: ['EncodedStatus'],
          sort: true
        },
        {
          name: this.LanguageSelector('Description', 'ملاحظات'),
          value: ['Notes']
        }
      ],
      OtherRecordsFields: [
        {
          name: 'index',
          noheader: true,
          type: 'index',
          print: false
        },
        {
          name: this.LanguageSelector('Date', 'التاريخ'),
          value: ['Date'],
          sort: true,
          type: 'date'
        },
        {
          name: this.LanguageSelector('Description', 'ملاحظات'),
          value: this.LanguageSelector(['Description'], ['DescriptionAr']),
          sort: true
        },
        {
          name: this.LanguageSelector('Ammuont', 'القيمة'),
          value: ['Amount'],
          sort: true,
          type: 'number',
          pricetag: true,
          total: true,
          bold: true,
          coloredNum: true
        }
      ]
    }
  },
  props: {
    DialogIndex: Number,
    DialogData: { default: '' }
  },
  methods: {
    ReadLedgerOders (LedgerID) {
      this.OrdersLoading = true
      if (LedgerID === undefined) {
        this.OrdersLoading = false
        return
      }
      this.Get('SuttelmentOrders?ledgerId=' + LedgerID).then(response => {
        this.CookiesDataLedgerOrders = response.map(element => {
          element.EncodedStatus = this.StatusMapper(element.Status)
          return element
        })
        this.OrdersLoading = false
      }, error => {
        this.OrdersLoading = false
        error.CookiesError = 'Error in reading Orders'
        this.OpenDialog('ErrorDialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
      })
    },
    ReadBalances () {
      this.Get('Financial/GetBalanceHis?ID=' + this.TheUser.Id).then(response => {
        this.CookiesDataBalanceHis = response
      }, error => {
        error.CookiesError = 'Error in reading Balances'
        this.OpenDialog('ErrorDialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
      })
    },
    ReadUser () {
      this.Get('Employee/GetDriver?ID=' + this.DialogData.Id).then(response => {
        this.ApplyUserData(response)
      }, error => {
        this.ApplyUserData(this.DialogData)
        error.CookiesError = 'Error in reading Driver'
        this.OpenDialog('ErrorDialog', 'Error', error) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
      })
    },
    NewTrans () {
      var TData = {}
      TData.Category = 'Driver'
      TData.Account = this.TheUser.DriverBalance
      TData.Header = this.TheUser.Employee.Name
      this.OpenDialog('NewTrans', this.LanguageSelector('New Transaction', 'حركة جديدة'), TData) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
    },
    Settlement () {
      var TData = {}
      TData.Category = 'Driver'
      TData.APIURL = 'Financial/SuttleBalance' + '?BalanceId=' + this.DeepFetcher(this.TheUser, ['DriverBalance', 'ID'])
      TData.Header = this.DeepFetcher(this.TheUser, ['Employee', 'Name'])
      TData.NetAmmount = this.DeepFetcher(this.CookiesCashLedger, ['NetBalance'])
      TData.BalanceType = 'Crediter'
      this.OpenDialog('Settlement', this.LanguageSelector('Settlement', 'تسوية حساب'), TData) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
    },
    OpenOlderBalance (Account) {
      this.Console(Account, 'background: blue;')
      var CashLedger = this.LedgerFinder(Account.ledgerHis, this.LedgersMapper.D_Cash, 1)
      this.Console(CashLedger, 'background: blue;')
      if (CashLedger === null || CashLedger === undefined) {
        return
      }
      Account.LedgerID = CashLedger.ID
      Account.UserName = this.TheUser.Employee.Name
      Account.AccountID = this.TheUser.DriverBalance.ID
      Account.UserType = 'Driver'
      this.OpenDialog('BalanceHis', this.LanguageSelector('Account History', 'تاريخ الحساب'), Account) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
    },
    ApplyUserData (User) {
      this.TheUser = this.DeepCloner(User)
      var CashLedger = this.LedgerFinder(this.DeepFetcher(this.TheUser, ['DriverBalance', 'ledgers']), this.LedgersMapper.D_Cash, 1)
      this.CookiesCashLedger = CashLedger
      if (CashLedger === null || CashLedger === undefined) {
        return
      }
      this.ReadLedgerOders(CashLedger.ID)
      this.ReadBalances()
    },
    printIT (x) {
      var bodd = document.getElementById('TableToPrint' + x)
      this.$store.state.Printing = bodd.cloneNode([true])
    },
    OpenOlderBalances () {
      var DData = this.DialogData
      DData.BalanceType = 'Driver'
      this.OpenDialog('OlderBalances', this.LanguageSelector('Account History', 'تاريخ الحساب'), this.DialogData) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
    }
  },
  mounted () {
    if (!this.Access('FinancialRead')) {
      return
    }
    // this.ApplyUserData(this.DialogData)
    this.ReadUser()
    try {
      var DialogPos = document.getElementById('CookiesDialog_' + this.DialogIndex).offsetTop - 60
      window.scrollTo(0, DialogPos)
    } catch (error) {
      console.log('error: ', error.message)
    }
  },
  computed: {
    CurrentDialogs () {
      return this.$store.getters.CurrentDialogsLength
    }
  },
  watch: {
    CurrentDialogs: function (newVal, oldVal) { // watch it
      if (newVal < oldVal) {
        this.ReadUser()
      }
    }
  }
}
</script>

<style scoped>
.DialogBody{
  /* width: 800px; */
  max-width: 95vw;
}
.DialogContainer{
  padding: 50px;
}
@media (max-width: 500px) {
  .FlexBreaker{
    flex-direction: column;
  }
  .FlexBreaker > *{
    width: 80% !important;
  }
  .DialogContainer{
    padding: 1em;
  }
  .CookiesDialogdBody{
    font-size: 3vw;
  }
}
@media (max-width: 300px) {
  .CookiesDialogdBody{
    font-size: 4vw;
  }
}
.CookiesInputHolder{
  height: 30px;
  width: 200px;
  border: none;
  border-radius: var(--rad2);
  flex: auto;
  padding: 10px 25px;
  outline: none;
  font-size: 17px;
  margin: 6px;
  position: relative;
}

.CookiesInputInside::placeholder{
  opacity: 0.35;
}
.CookiesRowSpacer{
  width: 100%;
  height: 20px;
}

.CookiesNumberInput{
  display: flex;
  margin: auto;
  border-radius: var(--rad3);
  overflow: hidden;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.ErrorBorder{
  border: solid var(--colorr2) 2px;
  padding: 8px 23px;
}

.barcode{
  display: flex;
  justify-content: center;
  width:300px;
  max-width:100%;
  height:100px;
  background: var(--white);
  border: solid 1px rgb(167, 167, 167);
  border-radius: var(--rad3);
  overflow: hidden;
  filter: drop-shadow(var(--shadow1));
}
.UserImage{
  width: 10em;
  height: 10em;
  margin-bottom: 1.5em;
  background-color: var(--shade2);
  border-radius: 5em;
  cursor: pointer;
  box-shadow: inset var(--shadow1);
  background-size: cover;
  background-position: center;
}
.UserImage > input{
  width: 0;
  height: 0;
  pointer-events: none;
}
.Cookies_TableButtons > tr:hover{
  background: v-bind('$store.getters.Theme.BG6');
  filter: drop-shadow(var(--shadow1));
}
.Cookies_TableButtons > tr{
  cursor: pointer;
  height: 3em;
  transition-duration: 0.2s;
  transition-property: filter, background;
}
.Cookies_TableButtons > tr > td.Arrow{
  transition-duration: 0.2s;
  transition-property: transform;
  padding-right: 1em !important;
}
.Cookies_TableButtons > tr:hover > td.Arrow{
  transform: translateX(0.2em);
}
.Cookies_TableButtons{
  padding: 1em;
}
.PrintButton{
  width: 6em;
  border-radius: 5em;
  background: v-bind('$store.getters.Theme.BG6');
  padding: 0.4em 0.4em;
  cursor: pointer;
  filter: drop-shadow(var(--shadow0));
  transition-property: transform, filter;
  transition-duration: 0.2s;
}
.PrintButton:hover{
  filter: drop-shadow(var(--shadow1));
  transform: translateY(-0.2em);
}
</style>
